export const LOCALIZED_INPUT = 'LOCALIZED_INPUT';
export const INITIALIZE_COMPONENT = 'INITIALIZE_COMPONENT';
export const SET_ERROR = 'SET_ERROR';
export const CLEAR_ERROR = 'CLEAR_ERROR';
